module.exports = __webpack_public_path__ + "static/media/home-care-card-5.6153cf11.png";